export default "__VITE_ASSET__ASwOYnBk__"